export type ApiErrorKind =
  | 'network'
  | 'authorization'
  | 'forbidden'
  | 'validation'
  | 'not-found'
  | 'unavailable'
  | 'unknown';

export interface ApiError {
  kind: ApiErrorKind;
  message: string;
  statusCode?: number;
  details?: unknown;
  requestId?: string | null;
}

export const createApiError = (
  kind: ApiErrorKind,
  message: string,
  statusCode?: number,
  details?: unknown,
  requestId?: string | null
): ApiError => ({
  kind,
  message,
  statusCode,
  details,
  requestId: requestId || null,
});

export const isApiError = (value: unknown): value is ApiError => {
  return Boolean(
    value &&
      typeof value === 'object' &&
      'kind' in value &&
      'message' in value
  );
};
